<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap">
    <div class="w-full flex flex-col items-center gap-6">
        <h2>Deine Fragen. Unsere Lösungen.</h2>
        <p class="max-w-screen-sm text-center">
            Sende uns ganz einfach über das Formular eine Anfrage, wir werden uns schnellstmöglich
            bei dir melden. Du kannst uns natürlich auch über die alternativen Wege
            kontaktieren. Wir freuen uns darauf, dir zu helfen!
        </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-auto">
            <div class="card bg-dark !spacing-sm !rounded-medium">
                <div class="flex flex-col gap-4 h-full">
                    <h2 class="font-normal text-white text-xl">Termin vereinbaren</h2>

                    <p class="text-white text-sm">
                        Vereinbare dir ein kostenloses und unverbindliches Erstgespräch via Calendly
                    </p>

                    <wci-button
                        (click)="openCalendly()"
                        label="Termin vereinbaren"
                        class="mt-auto"
                        buttonClass="!px-4 !py-2 !text-sm [&>svg]:!h-5">
                        Termin vereinbaren
                    </wci-button>
                </div>
            </div>

            <div class="card bg-dark !spacing-sm !rounded-medium !bg-[#075e54]">
                <div class="flex flex-col gap-4 h-full">
                    <h2 class="font-normal text-white text-xl">WhatsApp</h2>

                    <p class="text-white text-sm">Kontaktiere uns gerne direkt auf WhatsApp</p>

                    <wci-button
                        href="https://wa.me/436603878395"
                        target="_blank"
                        label="WhatsApp öffnen"
                        class="mt-auto"
                        variant="secondary"
                        buttonClass="!px-4 !py-2 !text-sm [&>svg]:!h-5">
                        WhatsApp öffnen
                    </wci-button>
                </div>
            </div>

            <div class="card !spacing-sm !rounded-medium">
                <div class="flex flex-col gap-4 h-full">
                    <h2 class="font-normal text-xl">Telefon</h2>

                    <p class="text-sm">
                        Während der Geschäftszeiten sind wir auch gerne telefonisch erreichbar
                    </p>

                    <wci-button
                        href="tel:+436603878395"
                        label="Jetzt anrufen"
                        class="mt-auto"
                        variant="secondary"
                        buttonClass="!px-4 !py-2 !text-sm [&>svg]:!h-5">
                        +43 660 3878395
                    </wci-button>
                </div>
            </div>

            <div class="card !spacing-sm !rounded-medium">
                <div class="flex flex-col gap-4 h-full">
                    <h2 class="font-normal text-xl">E-Mail</h2>

                    <p class="text-sm">
                        Außerhalb der Geschäftszeiten sind wir gerne per E-Mail für dich da
                    </p>

                    <wci-button
                        href="mailto:hello@wecodeit.at"
                        label="Jetzt anrufen"
                        class="mt-auto"
                        variant="secondary"
                        buttonClass="!px-4 !py-2 !text-sm [&>svg]:!h-5">
                        hello&#64;wecodeit.at
                    </wci-button>
                </div>
            </div>
        </div>

        <div>
            <form [formGroup]="form" class="space-y-6">
                <div>
                    <label for="name" class="block mb-2 text-sm font-medium">Name</label>
                    <input
                        formControlName="name"
                        type="text"
                        id="name"
                        class="block p-3 w-full text-sm bg-muted rounded-lg border border-muted-dark focus:!outline-secondary-600 focus:!border-secondary-600"
                        placeholder="Wie ist dein Name?"
                        required />
                </div>
                <div>
                    <label for="email" class="block mb-2 text-sm font-medium">E-Mail</label>
                    <input
                        formControlName="email"
                        type="email"
                        id="email"
                        class="bg-muted border border-muted-dark text-sm rounded-lg focus:!outline-secondary-600 focus:!border-secondary-600 block w-full p-2.5"
                        placeholder="mustermann@wecodeit.at"
                        required />
                </div>
                <div>
                    <label for="message" class="block mb-2 text-sm font-medium">Nachricht</label>
                    <textarea
                        formControlName="message"
                        id="message"
                        rows="6"
                        class="block p-2.5 w-full text-sm bg-muted rounded-lg border border-muted-dark focus:!outline-secondary-600 focus:!border-secondary-600"
                        placeholder=""></textarea>
                </div>

                <div class="absolute -left-[9999px]" aria-hidden="true" tabindex="-1">
                    <label for="website">Website</label>
                    <input formControlName="website" type="text" id="website" autocomplete="off" tabindex="-1" />
                </div>

                <div class="flex flex-col gap-3">
                    <div class="flex items-center">
                        <input
                            formControlName="pp"
                            id="checked-checkbox"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-secondary-600 bg-muted border-muted-dark rounded-sm focus:!outline-secondary-600 accent-secondary-600" />
                        <label for="checked-checkbox" class="ms-2 text-sm"
                            >Ich habe die
                            <a
                                class="font-normal"
                                target="_blank"
                                [href]="`${environment.baseURL}/rechtliches/datenschutz`"
                                >Datenschutzerklärung</a
                            >
                            gelesen und akzeptiere sie.</label
                        >
                    </div>
                </div>

                <button type="button"
                    (click)="submitRequest()"
                    [disabled]="(isLoading$ | async) || !form.valid"
                    class="btn primary">
                    @if (isLoading$ | async) {
                        Bitte warten...
                    } @else {
                        Anfrage senden
                    }
                </button>

                @if (isSuccess$ | async) {
                    <div
                        class="mt-4 p-4 text-sm rounded-lg text-green-800 bg-green-50 border border-green-200"
                        role="alert">
                        <p>
                            Vielen Dank für deine Nachricht, wir werden uns schnellstmöglich darum
                            kümmern.
                        </p>
                    </div>
                }

                @if (formError$ | async; as error) {
                    <div
                        class="mt-4 p-4 text-sm rounded-lg text-red-800 bg-red-50 border border-red-200"
                        role="alert">
                        <p>
                            <span class="font-normal"
                                >Ein Fehler ist aufgetreten. Bitte versuche es erneut.</span
                            >
                        </p>
                    </div>
                }
            </form>
        </div>
    </div>
</div>
